import { render, staticRenderFns } from "./EmployeeUnpause.vue?vue&type=template&id=34418998&"
import script from "./EmployeeUnpause.vue?vue&type=script&lang=js&"
export * from "./EmployeeUnpause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports